type TType<T> = T | "";

export const matchType = <T extends PropertyKey, U>(
  type: T | undefined | null,
  handlers: Record<TType<T>, U>,
) => {
  return handlers[type ?? ""];
};
